const defaults = {
  min: 1000 * 5,
  max: 1000 * 60 * 10,
  step: function doubler(min, i) {
    return min * Math.pow(2, i);
  }
};

export function wrap(func, conf) {
  const userConf = conf || {};
  const min =  userConf.min || defaults.min;
  const max = userConf.max || defaults.max;
  const step = userConf.step || defaults.step;
  let timeout;
  let i = 0;

  function calculateTimeout() {
    return Math.min(step(min, i), max);
  }

  const self = {
    retry: function retry() {
      timeout = setTimeout(wrapped, calculateTimeout());
      i++;
    },
    reset: function reset() {
      clearTimeout(timeout);
      i = 0;
    }
  };

  function wrapped() {
    return func(self.retry, self.reset);
  }

  wrapped();

  return self;
}
